// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"cb96b74a","606":"76c54896","709":"a8e6b105","787":"fa83daeb","912":"c2a7389c","933":"1226aa6e"}[chunkId] + ".chunk.js";
};